import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function RelatoriosPrivilegios({ user , permissions, setPermissions }) {
  return (
    <>
      <Header header={'Acesso a relatórios'} />
      {/* relatoriosImportacao
relatoriosDesalfandegamento
relatoriosExpediente
relatoriosControloQualidade
relatoriosFarmacovigilancia
relatoriosMedicamentos */}

      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosLicenciamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Licenciamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosImportacao'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Importação'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosDesalfandegamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Desalfandegamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosExpediente'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Expediente'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosControloQualidade'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Controlo de Qualidade'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosFarmacovigilancia'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Farmacovigilância'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'relatoriosMedicamentos'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatórios de Medicamentos'}
                  descricao={''}
                />
              , editable: false,
            },

          ]
        } />

    </>
  )
}
